// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar__item {
    display: flex;
    cursor: pointer;
    align-items: center;
    border-radius: 0.5rem;
    padding: 0.75rem;
    --tw-text-opacity: 1;
    color: rgb(55 65 81 / var(--tw-text-opacity, 1));
    transition-property: all;
    transition-delay: 150ms;
    transition-duration: 150ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1)
}
.sidebar__item:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(79 70 229 / var(--tw-text-opacity, 1))
}
.sidebar__item--title {
    width: 100%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 600;
    text-transform: capitalize;
    letter-spacing: 0.1em;
    transition-delay: 500ms;
    transition-duration: 300ms
}`, "",{"version":3,"sources":["webpack://./src/components/global/Sidebar/SidebarItem/sidebarItem.css"],"names":[],"mappings":"AACI;IAAA,aAAgK;IAAhK,eAAgK;IAAhK,mBAAgK;IAAhK,qBAAgK;IAAhK,gBAAgK;IAAhK,oBAAgK;IAAhK,gDAAgK;IAAhK,wBAAgK;IAAhK,uBAAgK;IAAhK,0BAAgK;IAAhK;AAAgK;AAAhK;IAAA,kBAAgK;IAAhK,4DAAgK;IAAhK,oBAAgK;IAAhK;AAAgK;AAGhK;IAAA,WAA+F;IAA/F,+LAA+F;IAA/F,mBAA+F;IAA/F,oBAA+F;IAA/F,gBAA+F;IAA/F,0BAA+F;IAA/F,qBAA+F;IAA/F,uBAA+F;IAA/F;AAA+F","sourcesContent":[".sidebar__item {\n    @apply flex items-center p-3 rounded-lg cursor-pointer text-gray-700 transition-all ease-in-out duration-150 delay-150 hover:bg-indigo-100 hover:text-indigo-600;\n}\n.sidebar__item--title {\n    @apply w-full text-sm capitalize tracking-widest font-semibold transform duration-300 delay-500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
